import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState
} from './seasons.action';
import { Seasons, SportsAssociation } from './seasons.model';

export interface SeasonsRecordsState {
    listData: Seasons[];
    singleData: Seasons;
    sportsAssociation: SportsAssociation[];
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: SeasonsRecordsState = {
    listData: [],
    sportsAssociation: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const SeasonsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total, sportsAssociation }) => {
        return { ...state, listData, total, sportsAssociation, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData, sportsAssociation }) => {
        return { ...state, singleData, sportsAssociation, error: null };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);